import React from 'react';
import {observer} from 'mobx-react';
import {Panel, AvatarList} from 'shared/components';
import {ReviewRow} from 'main/components/flow';
import {t} from 'shared/core';

const Review = observer(({uiState}) => {
  const {match, policy} = uiState;
  const editRoute = (step) => `/manage/policies/${match.params.id}/edit/${step}`;

  return (
    <div>
      <Panel.Header
        title={t('expenses.manage.policies.edit.Review your policy')}
        description={t('expenses.manage.policies.edit.Hover over a section and click edit to make changes.')}
      />
      <ReviewRow
        title='expenses.manage.policies.edit.Policy Name'
        value={policy.name}
        editRoute={editRoute('policy_details')}
      />
      <ReviewRow
        title='expenses.manage.policies.edit.Approvers'
        value={policy.approvers.map(a => a.name).join(', ')}
        editRoute={editRoute('approvers')}
      />
      <ReviewRow
        title='expenses.manage.policies.edit.steps.Employees'
        editRoute={editRoute('employees')}
        lastRow
      >
        <AvatarList employees={policy.employees} moreModalEnabled/>
      </ReviewRow>
    </div>
  );
});

export default Review;
